// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3dWgL","icon":"styles_icon__k6pMu"};